import React from 'react';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';

const Editpurchaseincome = () => {
  return (
    <div>


<div className="row mx-2">
        <div className="col-md-12 col-lg-12 col-xl-12 mt-4">
          <div className="card ">
            <div className="card-header bg bg-dark ">
              <h4 className="text-white"> Edit Purchase Income</h4>
            </div>
            <div className="card-body ">
              <div className="table-responsive">
              <table className="table table-bordered text-nowrap mb-0 ">
                <thead>
                  <tr>
                    <th>Total Income</th>
                    <th>RE-Income</th>
                    <th>Vendor Income</th>
                    <th>Self Perchase Income</th>
                    <th>Frinchaise Income</th>
                    <th>Admin Income</th>
                    <th>Status</th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>C234</td>
                    <td>Mi LED Smart TV 4A 80 </td>
                    <td>INR 14,500</td>
                    <td>500</td>
                    <td>2,977</td>
                    <td>2,977</td>

                    <td>
                    <Link to="/Editincomeadmin">   <Button variant="danger">Edit Income</Button>{' '} </Link> </td>
                  </tr>
                  <tr>
                    <td>C389</td>
                    <td>Thomson R9 122cm (48 inch) Full HD LED TV</td>
                    <td>INR 30,000	</td>
                    <td>500</td>
                    <td>2,977</td>
                    <td>2,977</td>

                    <td><Button variant="danger">Edit Income</Button>{' '}</td>
                  </tr>
                  <tr>
                    <td>C936</td>
                    <td>Vu 80cm (32 inch) HD Ready LED TV</td>
                    <td>	INR 13,200</td>
                    <td>500</td>
                    <td>999</td>
                    <td>2,977</td>
                    <td><Button variant="danger">Edit Income</Button>{' '}</td>
                  </tr>
                  <tr>
                    <td>C493</td>
                    <td>Micromax 81cm (32 inch) HD Ready LED TV</td>
                    <td>	INR 13,200</td>
                    <td>500</td>
                    <td>998</td>
                    <td>2,977</td>
                    <td><Button variant="danger">Edit Income</Button>{' '}</td>
                  </tr>
                  <tr>
                    <td>C729</td>
                    <td>HP 200 Mouse & Wireless Laptop Keyboard</td>
                    <td>	INR 13,200  </td>
                    <td>500</td>
                    <td>888</td>
                    <td>2,977</td>
                    <td>

                        <Button variant="danger">Edit Income</Button>{' '}
                        </td>
                  </tr>
                  
                  
                </tbody>
                <p className="mt-1"><Button variant="primary">View All</Button>{' '}</p>
              </table>

              </div>
            </div>
          </div>
        </div>
      </div> 

    </div>
  )
}

export default Editpurchaseincome;